import { render, staticRenderFns } from "./EventoLocation.vue?vue&type=template&id=080c85b6"
import script from "./EventoLocation.vue?vue&type=script&setup=true&lang=js"
export * from "./EventoLocation.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports